(() => {
  const button = document.getElementById('vanity-back-to-top');
  const key = () => 'vanity-scroll-v1:' + location.pathname + location.search;
  let restoring = false;
  let frame = 0;
  let lastScroller = null;
  let controller = null;
  let saveTimer = 0;
  const navigation = performance.getEntriesByType('navigation')[0];
  let saved = null;
  try {
    if (navigation && ['reload', 'back_forward'].includes(navigation.type)) saved = JSON.parse(sessionStorage.getItem(key()) || 'null');
  } catch {}
  if ('scrollRestoration' in history) history.scrollRestoration = saved ? 'manual' : 'auto';

  function snapshot() {
    if (restoring) return;
    const lists = Array.from(document.querySelectorAll('results-list[section-id]')).map(list => ({
      id: list.getAttribute('section-id'),
      count: list.vanityVisibleCount || 8,
    }));
    const outlet = document.getElementById('vanity-outlet');
    const candidates = Array.from(document.querySelectorAll('.product-grid__item[data-product-id], .vo-card[data-product-id]'));
    const card = candidates.find(node => !node.hidden && !node.hasAttribute('data-vanity-card-hidden') && node.getBoundingClientRect().bottom > 0 && node.getBoundingClientRect().top < innerHeight);
    const section = card?.closest('.shopify-section') || Array.from(document.querySelectorAll('main .shopify-section')).find(node => node.getBoundingClientRect().bottom > 0);
    const anchor = card || section;
    const state = {
      y: scrollY, x: scrollX, lists,
      outlet: outlet?.vanityVisibleCount || 8,
      anchor: anchor ? {product: card?.dataset.productId || '', section: section?.id || '', offset: anchor.getBoundingClientRect().top} : null,
    };
    try { sessionStorage.setItem(key(), JSON.stringify(state)); } catch {}
  }

  function currentScroller() {
    if (lastScroller?.isConnected && lastScroller.getClientRects().length && lastScroller.scrollTop > 0) return lastScroller;
    return null;
  }

  function updateButton() {
    frame = 0;
    if (!button) return;
    const scroller = currentScroller();
    const dialog = scroller?.closest('dialog[open]');
    const parent = dialog || document.body;
    if (button.parentElement !== parent) parent.append(button);
    button.hidden = (scroller ? scroller.scrollTop : scrollY) < Math.max(500, innerHeight * 0.7);
  }

  function onScroll(event) {
    const target = event.target;
    if (target instanceof HTMLElement && target !== document.documentElement && target !== document.body && target.scrollHeight > target.clientHeight) lastScroller = target;
    else if (target === document) lastScroller = null;
    if (!frame) frame = requestAnimationFrame(updateButton);
    clearTimeout(saveTimer);
    saveTimer = setTimeout(snapshot, 160);
  }

  function waitUntil(predicate, signal, timeout = 20000) {
    return new Promise(resolve => {
      const start = performance.now();
      const check = () => {
        if (signal.aborted || predicate() || performance.now() - start > timeout) return resolve();
        setTimeout(check, 80);
      };
      check();
    });
  }

  function anchorElement(state) {
    const anchor = state.anchor;
    if (!anchor) return null;
    const scope = anchor.section ? document.getElementById(anchor.section) : document;
    if (anchor.product && scope) {
      const card = Array.from(scope.querySelectorAll('.product-grid__item[data-product-id], .vo-card[data-product-id]')).find(node => node.dataset.productId === anchor.product && !node.hidden && !node.hasAttribute('data-vanity-card-hidden'));
      if (card) return card;
    }
    return anchor.product ? null : scope;
  }

  async function restore(state) {
    if (!state || !Number.isFinite(state.y)) return;
    controller?.abort();
    controller = new AbortController();
    const signal = controller.signal;
    restoring = true;
    try {
      for (const entry of state.lists || []) {
        let list;
        await waitUntil(() => {
          list = Array.from(document.querySelectorAll('results-list[section-id]')).find(node => node.getAttribute('section-id') === entry.id);
          return list && typeof list.restoreVanityVisibleCount === 'function' && !list.querySelector('[ref="grid"][aria-busy="true"]');
        }, signal);
        if (signal.aborted) return;
        if (list?.restoreVanityVisibleCount) await list.restoreVanityVisibleCount(entry.count, signal);
      }
      const outlet = document.getElementById('vanity-outlet');
      if (outlet && state.outlet > 8) {
        await waitUntil(() => outlet.dataset.catalogReady === 'true' && typeof outlet.restoreVanityVisibleCount === 'function', signal);
        if (!signal.aborted) outlet.restoreVanityVisibleCount?.(state.outlet);
      }
      if (signal.aborted) return;
      const apply = () => {
        if (signal.aborted) return;
        const anchor = anchorElement(state);
        const top = anchor ? scrollY + anchor.getBoundingClientRect().top - state.anchor.offset : state.y;
        window.scrollTo({left: state.x || 0, top, behavior: 'instant'});
        updateButton();
      };
      apply();
      for (const delay of [80, 240, 650, 1300]) {
        await new Promise(resolve => setTimeout(resolve, delay));
        if (signal.aborted) return;
        apply();
      }
    } finally {
      restoring = false;
      updateButton();
    }
  }

  function userInput() {
    if (controller) controller.abort();
    restoring = false;
  }
  document.addEventListener('pointerdown', userInput, {capture: true, passive: true});
  document.addEventListener('touchstart', userInput, {capture: true, passive: true});
  document.addEventListener('wheel', userInput, {capture: true, passive: true});
  document.addEventListener('keydown', userInput, true);
  document.addEventListener('scroll', onScroll, {capture: true, passive: true});
  document.addEventListener('toggle', updateButton, true);
  document.addEventListener('close', updateButton, true);
  window.addEventListener('resize', updateButton, {passive: true});
  window.addEventListener('pagehide', snapshot);
  document.addEventListener('visibilitychange', () => { if (document.visibilityState === 'hidden') snapshot(); });
  window.addEventListener('pageshow', event => {
    if (event.persisted && !saved) {
      try { saved = JSON.parse(sessionStorage.getItem(key()) || 'null'); } catch {}
    }
    if (saved) {
      if ('scrollRestoration' in history) history.scrollRestoration = 'manual';
      const state = saved; saved = null; restore(state);
    }
    else updateButton();
  });
  button?.addEventListener('click', event => {
    event.preventDefault();
    event.stopPropagation();
    userInput();
    const scroller = currentScroller();
    const options = {top: 0, left: 0, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'};
    if (scroller) scroller.scrollTo(options);
    else window.scrollTo(options);
  });
  updateButton();
})();
